export const SESSION_RINGING = "ringing";
export const SESSION_ANSWERED = "answered";
export const SESSION_FAILED = "failed";
export const SESSION_ENDED = "ended";
export const SESSION_MUTED = "muted";
export const SESSION_HOLD = "hold";
export const SESSION_UNHOLD = "unhold";
export const SESSION_REFER = "refer";
export const SESSION_REPLACES = "replaces";
export const SESSION_ICE_READY = "ice-ready";
export const SESSION_ADD_STREAM = "add-stream";
export const SESSION_TRACK = "track";
export const SESSION_ACTIVE = "active";
export const UA_CONNECTING = "connecting";
export const UA_CONNECTED = "connected";
export const UA_DISCONNECTED = "disconnected";
export const UA_REGISTERED = "registered";
export const UA_UNREGISTERED = "unregistered";
export const UA_START = "start";
export const UA_STOP = "stop";
